import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Collapsible from "react-collapsible";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
const Sidebar = ({ show, handleClose }) => {
  const { t, i18n } = useTranslation("usertable");
  const [lang, setLang] = useState(Cookies.get("i18next") || "en");
  return (
    <>
      <div>
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          className="side__bar"
        >
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul className="sidebar_sub_menu text-white mt-3">
              <li>
                <NavLink to="/">{t("home")}</NavLink>
              </li>
              <li>
                <NavLink to="/about">{t("aboutus")}</NavLink>
              </li>
              <Collapsible
                trigger={t("ourproducts")}
                triggerTagName="div"
                triggerOpenedClassName="icon_close"
                triggerClassName="iconAdd"
                open={false}
              >
                <ul className="sidebar_sub_menu text-white mt-3">
                  <li>
                    <NavLink to="/doctors">CELL MARQUE</NavLink>
                  </li>
                  <li>
                    <NavLink to="/doctorsTwo">DREAMPATH</NavLink>
                  </li>
                  <li>
                    <NavLink to="/doctorDetails">VISIA IMAGING</NavLink>
                  </li>
                </ul>
              </Collapsible>
              <li>
                <NavLink to="/services">{t("ourservices")}</NavLink>
              </li>
              <li>
                <NavLink to="/refferences">{t("ourreferences")}</NavLink>
              </li>
              <li>
                <NavLink to="/contactUs">{t("contactUs")}</NavLink>
              </li>
            </ul>
            <span style={{ float: "right" }}>
              {lang === "en" ? (
                <a
                  onClick={() => {
                    i18n.changeLanguage("tr");
                    Cookies.set("i18next", "tr");
                    setLang("tr");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{ width: "25px" }}
                    src="/img/icon/turkey-2.png"
                    alt=""
                  />{" "}
                  <a style={{ margin: "auto", padding: "2px" }}>TR</a>
                </a>
              ) : (
                <a
                  onClick={() => {
                    i18n.changeLanguage("en");
                    Cookies.set("i18next", "en");
                    setLang("en");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{ width: "25px" }}
                    src="/img/icon/lang.png"
                    alt=""
                  />{" "}
                  <a style={{ margin: "auto", padding: "2px", color: "white" }}>
                    EN
                  </a>
                </a>
              )}
            </span>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Sidebar;
